import { ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomDialogContentDirective } from '../../directives/custom-dialog-content.directive';
import { GusDialogConfig } from '../../models/dialog.models';

@Component({
  selector: 'gus-dialog-footer',
  templateUrl: './dialog-footer.component.html',
  styleUrl: './dialog-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogFooterComponent {
  @Input() isLoading: boolean = false;

  @Output() primaryButtonClicked: EventEmitter<boolean> = new EventEmitter();

  @Output() secondaryButtonClicked: EventEmitter<boolean> = new EventEmitter();

  @ContentChild(CustomDialogContentDirective) protected customContent?: CustomDialogContentDirective;

  constructor(@Inject(MAT_DIALOG_DATA) public readonly config: GusDialogConfig) {}
}
